module.exports = __webpack_public_path__ + "img/feb.50d70b9e.jpg";